<template>
    <v-loading-button :prevent-default="true" @clicked="$emit('clicked')" :class-name="`block mx-${spacing} ${extraClassName}`">
        <img :src="'/icons/actions/'+icon+'.svg'" :class="`h-${size} w-${size} opacity-50 hover:opacity-100`" />
    </v-loading-button>
</template>

<script>
    import LoadingButtonVue from './../_Form/LoadingButton.vue'
    export default {
        props: {
            icon: {
                type: String,
                default: 'delete'
            },
            size: {
                type: String,
                default: '4'
            },
            spacing: {
                type: String,
                default: '2'
            },
            extraClassName: {
                type: String,
                default: ''
            }
        },
        components: {
            'v-loading-button': LoadingButtonVue
        }
    }
</script>